import React from "react";
import Icon from "src/icons";

const ManageSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 18 15">
    <path
      fill="#FFF"
      fillRule="nonzero"
      d="M3.75 3.32v8.36h2.07l-2.89 2.89L0 11.68h2.07V3.32H0L2.93.43l2.89 2.89H3.75zm3.32-1.64h10v1.64h-10V1.68zm0 11.64v-1.64h10v1.64h-10zm0-5V6.68h10v1.64h-10z"
      opacity=".7"
    />
  </svg>
);
export const ManageMetricIcon = (props) => <Icon component={ManageSvg} {...props} />;
